<template>
    <ScrollTop :pt="{root: {class: 'scroll_to_top'}}">
        <template #icon>
            <i class="pi pi-chevron-up scroll_to_top__icon"></i>
        </template>
    </ScrollTop>
</template>

<script>
import ScrollTop from "primevue/scrolltop";

export default {
    name: "ScrollToTop",
    components: {
        ScrollTop,
    }
}
</script>
<style scoped>
.scroll_to_top {
    bottom: 80px;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background-color: #68AA13 !important;
    z-index: 100000 !important;
}
.scroll_to_top__icon {
    width: 16px;
    height: 16px;
    color: #fff;
}
</style>
